import { onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';

interface LoaderMessage {
    text: string;
    duration: number;
}

export function useGbgLoaderStatus() {
    const TRANSLATION_KEY = 'basic.gbgLoaderStatus';
    const { t } = useI18n();

    const messages: LoaderMessage[] = [
        { text: `${TRANSLATION_KEY}.message1`, duration: 5 },
        { text: `${TRANSLATION_KEY}.message2`, duration: 9 },
        { text: `${TRANSLATION_KEY}.message3`, duration: Infinity },
    ];

    let timer: ReturnType<typeof setInterval> | null = null;
    let currentIndex = 0;
    let elapsed = 0;

    function setLoaderText(key: string) {
        const el = document.querySelector(
            '.gbg-loader-title'
        ) as HTMLElement | null;
        if (el) el.textContent = t(key);
    }

    function startGbgLoaderStatus() {
        stopGbgLoaderStatus();
        currentIndex = 0;
        elapsed = 0;
        setLoaderText(messages[0].text);

        timer = setInterval(() => {
            elapsed++;
            const current = messages[currentIndex];
            if (elapsed > current.duration) {
                currentIndex++;
                if (currentIndex < messages.length) {
                    setLoaderText(messages[currentIndex].text);
                    elapsed = 1;
                } else {
                    stopGbgLoaderStatus();
                }
            }
        }, 1000);
    }

    function stopGbgLoaderStatus() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    }

    onUnmounted(() => stopGbgLoaderStatus());

    return {
        startGbgLoaderStatus,
        stopGbgLoaderStatus,
    };
}
